window.startTimerLockoutTimer = function startTimerLockoutTimer(startedAtTimestamp, endedAtTimestamp, callback = null) {
    const hoursEl = $('#timer-lockout-modal #hours');
    const minutesEl = $('#timer-lockout-modal #minutes');
    const secondsEl = $('#timer-lockout-modal #seconds');

    const endedAt = new Date(endedAtTimestamp);

    const now = new Date();

    const totalSeconds = Math.floor((endedAt - now) / 1000);
    if (totalSeconds <= 0) {
        hoursEl.text('00');
        minutesEl.text('00');
        secondsEl.text('00');

        clearTimeout(window.timerLockoutTimeout);

        $('#timer-lockout-modal').modal('hide');
        if (callback && typeof callback === 'function') {
            callback();
        }
        return;
        // Timer has ended
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    hoursEl.text(String(hours).padStart(2, '0'));
    minutesEl.text(String(minutes).padStart(2, '0'));
    secondsEl.text(String(seconds).padStart(2, '0'));

    // Update every second
    window.timerLockoutTimeout = setTimeout(() => {
        startTimerLockoutTimer(startedAtTimestamp, endedAtTimestamp, callback);
    }, 1000);
}

// on jquery ready

$(function () {
    const timerLockoutModal = $('#timer-lockout-modal');
    if ($(timerLockoutModal).length > 0) {
        const startedAtTimestamp = timerLockoutModal.data('started-at');
        const endedAtTimestamp = timerLockoutModal.data('expires-at');

        console.log('Timer Lockout Modal:', timerLockoutModal);
        console.log('Started At:', startedAtTimestamp);
        console.log('Ended At:', endedAtTimestamp);
        if (startedAtTimestamp && endedAtTimestamp) {
            $(timerLockoutModal).modal('show');
            startTimerLockoutTimer(startedAtTimestamp, endedAtTimestamp);
        }
    }
})

window.storeTimerLockout = function storeTimerLockout(
    timerLockoutData = {},
    formType = null,
    callback = null
) {
    timerLockoutData.service_id = $('#service').val();

    axios.post(
        route('timer-lockouts.store'),
        timerLockoutData
    ).then(function (response) {
        const data = response.data;

        if (
            data.status !== 'success' ||
            !data.data.timerLockout ||
            !data.data.timerLockout?.created_at ||
            !data.data.timerLockout?.ended_at
        ) {
            console.error('Error initializing timer lockout:', data);
            return;
        }

        $('#' + formType.toLowerCase() + '-init-timer-lockout-wrapper').addClass('d-none');
        $('#timer-lockout-modal').modal('show');
        window.startTimerLockoutTimer(
            data.data.timerLockout.created_at,
            data.data.timerLockout.ended_at,
            callback
        );
    })
}


require('./Services/VLC')
require('./Services/DLF')
require('./Services/LP')
